import { Stack, Typography } from '@mui/material';
import CustomAppBar from 'components/CustomAppBar/CustomAppBar';
import Logo from 'components/Layout/components/Logo/Logo';

export default function MyAppBar() {
  return (
    <CustomAppBar>
      <Stack sx={{ width: '100%' }} justifyContent="center" alignItems="center" direction="row" spacing={1}>
        <Logo />
        <Typography variant="h6" sx={{ color: 'black', fontWeight: 'bold' }}>تام</Typography>
      </Stack>
    </CustomAppBar>

  );
}
